export default __webpack_public_path__ + "static/media/bx-message-square-detail.fa146526.svg";